/**
 * api接口的统一出口
*/
import Login from '@/api/Login';
import account from '@/api/account';
import setting from '@/api/setting';
import operate from '@/api/operate';
import finance from '@/api/finance';
import merchant from '@/api/merchant';
import production from '@/api/production';
import order from '@/api/order';
import businessShare from '@/api/businessShare';
import marketing from '@/api/marketing';
import supplyChain from '@/api/supplyChain';
import blindBox from '@/api/blindBox'
import task from '@/api/task'
import PlatformPartner from '@/api/PlatformPartner'
import activity from '@/api/activity'
import apply from '@/api/apply'
export default {
    Login,
    apply,
    account,
    setting,
    finance,
    operate,
    merchant,
    production,
    order,
    businessShare,
    marketing,
    supplyChain,
    blindBox,
    task,
    PlatformPartner,
    activity
}



// WEBPACK FOOTER //
// ./src/api/index.js